import '../common/base';
import '../vue/top-advantages';
import { getSimpleVueHorizontalScroll } from '../vue/horizontal-scroll';

const horizontalScrollEl = cr$.byId('hotsite-slider');
if (horizontalScrollEl) {
    requestIdleCallback(() => {
        getSimpleVueHorizontalScroll(horizontalScrollEl.raw, true);
    });
}
